import { normalizeSearchQuery } from "@/lib/normalize-search-query";
import { orpc } from "@/utils/orpc.client";
import { QUERY_STALE_TIMES } from "@/utils/query-policies";

interface CompanySearchQueryOptionsInput {
  query: string;
  enabled?: boolean;
}

export function getCompanySearchQueryOptions({ query, enabled }: CompanySearchQueryOptionsInput) {
  const normalizedQuery = normalizeSearchQuery(query);
  return orpc.music.searchCompanies.queryOptions({
    input: { query: normalizedQuery, limit: 12 },
    enabled,
    staleTime: QUERY_STALE_TIMES.default,
  });
}
